"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
/** @jsx jsx */
var react_1 = require("@emotion/react");
var react_2 = require("react");
var constant_1 = require("../../constant");
var style_1 = require("../../style");
var utils_1 = require("../../style/utils");
var Text_1 = __importDefault(require("../Text"));
var headerStyle = function (theme) { return ({
    padding: theme.name === constant_1.DESIGN_SYSTEM ? '24px' : '20px 30px',
    borderBottom: theme.border,
}); };
var CardHeader = function (props) {
    var theme = react_1.useTheme();
    var style = react_2.useMemo(function () { return headerStyle(theme); }, [theme]);
    return react_1.jsx("div", __assign({ css: style }, props));
};
var titleStyle = react_1.css({
    fontSize: utils_1.pxToRem(14),
    lineHeight: 1.4,
    fontWeight: 600,
    textTransform: 'uppercase',
    color: '#001f32',
});
var Title = function (props) {
    var theme = react_1.useTheme();
    return theme.name === constant_1.DESIGN_SYSTEM ? (react_1.jsx(Text_1.default.Body, { size: "lg", weight: "semibold", color: style_1.DesignSystemThemeColor.Gray.DARK_4 }, props.children)) : (react_1.jsx("span", __assign({ css: titleStyle }, props)));
};
var subtitleStyle = react_1.css({
    fontSize: utils_1.pxToRem(12),
    lineHeight: 1.4,
    color: '#505C62',
});
var Subtitle = function (props) {
    var theme = react_1.useTheme();
    return theme.name === constant_1.DESIGN_SYSTEM ? (react_1.jsx(Text_1.default.Body, { color: style_1.DesignSystemThemeColor.Gray.LIGHT_1 }, props.children)) : (react_1.jsx("span", __assign({ css: subtitleStyle }, props)));
};
exports.default = Object.assign(CardHeader, { Title: Title, Subtitle: Subtitle });
